<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {TOUR, PRODUCT_NAME} from '@/utils/simpleTours/simple-tour-const'
    import {simpleTourStore} from '~/composables/store-accessor'

    @Component
    export class SimpleTourMixin extends Vue {
        get productStore() {
            return simpleTourStore
        }

        get productRuntimeStore() {
            return simpleTourRuntimeStore
        }

        get productType() {
            return TOUR
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default SimpleTourMixin
</script>
